import { AProvider } from "src/framework/providers/AProvider";

class CartoesBandeiraProvider extends AProvider {
    constructor() {
        super("/financeiro/cartoes_bandeiras");
    }
}
export const cartoesBandeiraProvider = new CartoesBandeiraProvider();
export { CartoesBandeiraProvider }